import React from 'react';
import { useHistory } from 'react-router-dom';
import AcceptanceNameAndPeriod from '../../../../presenters/AcceptanceNameAndPeriod';
import CancelToDetails from '../../../../controllers/CancelToDetails';
import Save from '../../controllers/Save';
import { dateTime } from '../../../../shared/packages/dateTime';
import styles from './index.module.scss';

const Header = () => {
  const { location } = useHistory();
  const { acceptance } = location.state?.from || {};

  return (
    <>
      <AcceptanceNameAndPeriod
        name={acceptance?.name}
        fromDate={dateTime(acceptance.fromDate)}
        toDate={dateTime(acceptance.toDate)}
      />
      <div className={styles.col}>
        <CancelToDetails />
        <Save />
      </div>
    </>
  );
};

export default Header;
